/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewAnswerer
 */
export interface NewAnswerer {
    /**
     * 
     * @type {string}
     * @memberof NewAnswerer
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NewAnswerer
     */
    receiverNickname: string;
    /**
     * 
     * @type {string}
     * @memberof NewAnswerer
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof NewAnswerer
     */
    birthday?: string;
    /**
     * 
     * @type {string}
     * @memberof NewAnswerer
     */
    relationship: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewAnswerer
     */
    qmailFrequency: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof NewAnswerer
     */
    questionSendType: NewAnswererQuestionSendTypeEnum;
}


/**
 * @export
 */
export const NewAnswererQuestionSendTypeEnum = {
    Line: 'Line',
    Email: 'Email'
} as const;
export type NewAnswererQuestionSendTypeEnum = typeof NewAnswererQuestionSendTypeEnum[keyof typeof NewAnswererQuestionSendTypeEnum];


/**
 * Check if a given object implements the NewAnswerer interface.
 */
export function instanceOfNewAnswerer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "receiverNickname" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "relationship" in value;
    isInstance = isInstance && "qmailFrequency" in value;
    isInstance = isInstance && "questionSendType" in value;

    return isInstance;
}

export function NewAnswererFromJSON(json: any): NewAnswerer {
    return NewAnswererFromJSONTyped(json, false);
}

export function NewAnswererFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewAnswerer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'receiverNickname': json['receiverNickname'],
        'email': json['email'],
        'birthday': !exists(json, 'birthday') ? undefined : json['birthday'],
        'relationship': json['relationship'],
        'qmailFrequency': json['qmailFrequency'],
        'questionSendType': json['questionSendType'],
    };
}

export function NewAnswererToJSON(value?: NewAnswerer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'receiverNickname': value.receiverNickname,
        'email': value.email,
        'birthday': value.birthday,
        'relationship': value.relationship,
        'qmailFrequency': value.qmailFrequency,
        'questionSendType': value.questionSendType,
    };
}

